import { useState } from "react";
import { Play } from "lucide-react";
import Reveal from "@/components/Reveal";

const VERSIONS = {
    en: {
        label: "English",
        src: "/videos/sens-civil-works-promo.mp4",
    },
    hi: {
        label: "हिंदी",
        src: "/videos/sens-civil-works-promo-hindi.mp4",
    },
};

export default function PromoVideoSection() {
    const [lang, setLang] = useState("en");

    return (
        <section className="noise-overlay relative bg-navy py-20 lg:py-28" data-testid="promo-video-section">
            <div className="blueprint-grid-dark absolute inset-0" aria-hidden="true" />
            <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
                <Reveal>
                    <div className="flex flex-wrap items-end justify-between gap-6">
                        <div>
                            <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber">Watch</p>
                            <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
                                The Consultancy in 30 Seconds
                            </h2>
                            <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-300">
                                A quick overview of who we are, what we review, and how an independent expert protects
                                your construction decisions.
                            </p>
                        </div>
                        <div className="flex border border-slate-600" role="group" aria-label="Video language">
                            {Object.entries(VERSIONS).map(([key, v]) => (
                                <button
                                    key={key}
                                    onClick={() => setLang(key)}
                                    className={`px-5 py-2.5 font-mono text-xs uppercase tracking-[0.18em] transition-colors duration-200 ${
                                        lang === key ? "bg-amber text-white" : "text-slate-300 hover:text-white"
                                    }`}
                                    data-testid={`video-lang-${key}`}
                                    aria-pressed={lang === key}
                                >
                                    {v.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </Reveal>
                <Reveal delay={0.12}>
                    <div className="tick-frame mt-12 bg-navy-900">
                        <video
                            key={lang}
                            controls
                            preload="metadata"
                            poster="/videos/promo-poster.jpg"
                            className="aspect-video w-full"
                            data-testid="promo-video-player"
                        >
                            <source src={VERSIONS[lang].src} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <p className="mt-4 flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-slate-400">
                        <Play size={12} className="text-amber" /> 30 seconds · English &amp; Hindi versions available
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
